import { Route, Navigate } from "react-router-dom";
import ActivateAccountPage from "../../../../../pages/login/ActivateAccountPage";
import DemoPage from "../../../../../pages/login/DemoPage";
import LoginPage from "../../../../../pages/login/LoginPage";
import PasswordRecoveryPage from "../../../../../pages/login/PasswordRecoveryPage";
import ResetPasswordPage from "../../../../../pages/login/ResetPasswordPage";
import { USER_ROUTES } from "../../../../../shared/routes/routes";

const usePublicRoutes = () => {
  return (
    <Route path={"/*"}>
      <Route path={""} element={<Navigate to={`/${USER_ROUTES.login}`} />} />
      <Route path={USER_ROUTES.login}>
        <Route path={""} element={<LoginPage />} />
        <Route path={USER_ROUTES.demoRequest} element={<DemoPage />} />
        <Route path={"*"} element={<Navigate to={`/${USER_ROUTES.login}`} />} />
      </Route>
      <Route path={USER_ROUTES.passwordRecovery} element={<PasswordRecoveryPage />} />
      <Route path={USER_ROUTES.resetPassword} element={<ResetPasswordPage />} />
      <Route path={USER_ROUTES.activateAccount} element={<ActivateAccountPage />} />
      <Route path={"*"} element={<Navigate to={`/${USER_ROUTES.login}`} />} />
    </Route>
  );
};

export default usePublicRoutes;
